import { useQueryClient } from '../../lib';
import { getAppInstallationsKey, getAppsKey } from '../../utils/keys';
const validate = (app, args) => {
    if ((args === null || args === void 0 ? void 0 : args.id) && (app === null || app === void 0 ? void 0 : app.id) !== (args === null || args === void 0 ? void 0 : args.id))
        return false;
    if ((args === null || args === void 0 ? void 0 : args.slug) && (app === null || app === void 0 ? void 0 : app.slug) !== (args === null || args === void 0 ? void 0 : args.slug))
        return false;
    return true;
};
const findAppInApps = (args, queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getAppsKey(),
    });
    let app;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const data = query === null || query === void 0 ? void 0 : query[1];
        (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.forEach(page => {
            var _a;
            (_a = page === null || page === void 0 ? void 0 : page.edges) === null || _a === void 0 ? void 0 : _a.forEach(edge => {
                if (validate(edge === null || edge === void 0 ? void 0 : edge.node, args)) {
                    app = {
                        ...app,
                        ...edge === null || edge === void 0 ? void 0 : edge.node,
                    };
                }
            });
        });
    });
    return app;
};
const findAppInAppInstallations = (args, queryClient) => {
    const queries = queryClient.getQueriesData({
        queryKey: getAppInstallationsKey(),
    });
    let app;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const data = query === null || query === void 0 ? void 0 : query[1];
        (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.forEach(page => {
            var _a;
            (_a = page === null || page === void 0 ? void 0 : page.edges) === null || _a === void 0 ? void 0 : _a.forEach(edge => {
                var _a, _b;
                if (validate((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.app, args)) {
                    app = {
                        ...app,
                        ...(_b = edge === null || edge === void 0 ? void 0 : edge.node) === null || _b === void 0 ? void 0 : _b.app,
                    };
                }
            });
        });
    });
    return app;
};
export const useCachedApp = (args) => {
    const queryClient = useQueryClient();
    return {
        ...findAppInApps(args, queryClient),
        ...findAppInAppInstallations(args, queryClient),
    };
};
//# sourceMappingURL=useCachedApp.js.map